export enum PaymentType {
  ACH = 'ACH',
  MANUAL = 'Manual',
  PLUGIN = 'Plugin',
  PLUGIN_REFUND = 'Plugin Refund'
}
